// extracted by mini-css-extract-plugin
export default {"fr-view":"Students_fr-view__9HjT+","student":"Students_student__gKJnD"};